import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const influencerList = (params = '') => Http.get(`/influencers-personal-info${serialize(params)}`)
export const influencerCreate = (params = '') => Http.post('/influencers-personal-info', params)
export const influencerByID = (params = '') => Http.get(`/influencers-personal-info/${params}`)
export const influencerUpdate = (params = '') => Http.put(`/influencers-personal-info/${params.id}`, params)
export const influencerDestroy = (params = '') => Http.delete(`/influencers-personal-info/${params.id}`)

const PROFESSIONAL_INCLUDE =
	'countries,languages,niches,gender_dominances,tiers,age_ranges,content_styles,brands,rate_cards,rate_card_bundles,portfolio_links,contact_type,availability_hour,availability_days'

export const professionalList = (params = {}) => {
	// Merge include into the params so serialize() builds a single, valid query
	// string. Appending "?include=" after serialize() produced a double "?",
	// corrupting the last param (e.g. order=asc?include=... → invalid order).
	const merged = { include: PROFESSIONAL_INCLUDE, ...(params && typeof params === 'object' ? params : {}) }
	return Http.get(`/influencers-professional-info${serialize(merged)}`)
}
export const professionalCreate = (params = '') => Http.post('/influencers-professional-info', params)
export const professionalByID = (params = '') =>
	Http.get(`/influencers-professional-info/${params}?include=${PROFESSIONAL_INCLUDE}`)
export const professionalUpdate = (params = '') => Http.put(`/influencers-professional-info/${params.id}`, params)
export const professionalDestroy = (params = '') => Http.delete(`/influencers-professional-info/${params.id}`)

export const socialList = (params = '') => Http.get(`/influencers-social-networks${serialize(params)}`)
export const socialCreate = (params = '') => Http.post('/influencers-social-networks', params)
export const socialByID = (params = '') => Http.get(`/influencers-social-networks/${params}`)
export const socialUpdate = (params = '') => Http.put(`/influencers-social-networks/${params.id}`, params)
export const socialDestroy = (params = '') => Http.delete(`/influencers-social-networks/${params.id}`)

export const documentList = (params = '') => Http.get(`/influencers-docs${serialize(params)}`)
export const documentCreate = (params = '') => Http.post('/influencers-docs', params)
export const documentByID = (params = '') => Http.get(`/influencers-docs/${params}`)
export const documentUpdate = (params = '') => Http.put(`/influencers-docs/${params.id}`, params)
export const documentDestroy = (params = '') => Http.delete(`/influencers-docs/${params.id}`)

export const professionalSendOnboarding = (id) => Http.post(`/influencers-professional-info/${id}/send-onboarding`)

// Admin: send a tokenized link letting the creator fill in whatever is
// missing from their profile (avatar, bio, niche, real followers) before it
// can be marked featured.
export const professionalSendProfileCompletionInvite = (id) =>
	Http.post(`/influencers-professional-info/${id}/send-profile-completion-invite`)

// Admin: approve/reject a new influencer registration (professional info id)
export const professionalReview = (id, status, notes = null) =>
	Http.patch(`/influencers-professional-info/${id}/review`, { status, notes })

// Admin: grant/revoke "Casting Oficial" status (always manual, never automatic)
export const professionalSetOfficialCasting = (id, official, notes = null, agencyEmailAlias = null) =>
	Http.patch(`/influencers-professional-info/${id}/official-casting`, {
		official,
		notes,
		agency_email_alias: agencyEmailAlias,
	})

// Admin: generate + send the standing Agency x Creator representation contract
// (Contrato de Representação Comercial) for signature — independent of the
// official-casting flag itself, since the contract usually needs to go out first.
export const professionalGenerateRepresentationContract = (id) =>
	Http.post(`/influencers-professional-info/${id}/representation-contract`)

export const influencerBulkDelete = (ids) => Http.post('/influencers-personal-info/bulk-delete', { ids })
export const influencerBulkStatus = (ids, status) => Http.patch('/influencers-personal-info/bulk-status', { ids, status })
export const influencerBulkShow   = (ids, is_public) => Http.patch('/influencers-personal-info/bulk-show', { ids, is_public })

export const professionalToggleShow = (id, is_public) =>
	Http.patch(`/influencers-professional-info/${id}/toggle-show`, { is_public })

// Admin: influencer social connections (media-kit metrics + verified)
export const socialConnectionsList    = (userId) => Http.get(`/influencers/${userId}/social-connections`)
export const socialConnectionUpsert   = (userId, params) => Http.post(`/influencers/${userId}/social-connections`, params)
export const socialConnectionDestroy  = (userId, id) => Http.delete(`/influencers/${userId}/social-connections/${id}`)

// Static lookups behind the /trails-form fields — same public endpoints the
// creator-facing form uses, so the admin picker always matches what a
// creator would have seen when they filled it in.
export const lookupGameGenres        = () => Http.get('/public/journalist-lookups/game-genres')
export const lookupContentPlatforms  = () => Http.get('/public/influencer-lookups/social-content-platforms')
export const lookupMetricValueRanges = () => Http.get('/public/influencer-lookups/metric-value-ranges')
export const lookupContactTypes      = () => Http.get('/public/influencer-lookups/contact-types')
export const lookupAvailabilityHours = () => Http.get('/public/influencer-lookups/availability-hours')
export const lookupAvailabilityDays  = () => Http.get('/public/influencer-lookups/availability-days')
export const lookupContentFormats    = () => Http.get('/public/influencer-lookups/content-formats')
export const lookupAudienceProfiles  = () => Http.get('/public/journalist-lookups/audience-profiles')
export const lookupRegions           = () => Http.get('/public/regions')
